import React, {useEffect, useState} from "react";
import {useAppKitAccount, useAppKitNetwork, useAppKitProvider, useDisconnect} from "@reown/appkit/react";
import {bsc, solana} from "@reown/appkit/networks";
import {Alert, Snackbar, useMediaQuery} from "@mui/material";
import {completeWalletLogin} from "../api";
import {storeReferrerData} from "../../../../apihelper/profile";
import json2mq from "json2mq";

const ConnectButton = () => {
    const {address, isConnected} = useAppKitAccount();
    const {walletProvider} = useAppKitProvider();
    const [alertMessage, setAlertMessage] = useState("");
    const [snackbaropen, setSnackbarOpen] = useState(false);
    const [severity, setSeverity] = useState("info");

    const [solanaAddress, setSolanaAddress] = useState("");

    const handleLoginClick = async () => {
        console.log("address", address);
        const isSolana = address && !address.startsWith("0x") && address.length >= 32 && address.length <= 44;

        const data = await completeWalletLogin(address, isSolana);
        if (data.code === "200") {
            localStorage.setItem("cw_portfolio_user", JSON.stringify(data.data));

            const referrerId = localStorage.getItem("referrerId");

            if (referrerId) {
                try {
                    // Make an API call to store referrer-referee relationship
                    await storeReferrerData(referrerId, data.data.user_id, data.state); // Use logged-in user's ID

                    localStorage.removeItem("referrerId");
                    window.location.replace("/account");
                } catch (error) {
                    console.error("Error storing referrer data:", error);
                }
            }
            // setIsLoggedIn(true);

            let originalUrl = sessionStorage.getItem("originalUrl") || "/portfolio-gallery";
            if (originalUrl === "/login" || originalUrl === "/") {
                originalUrl = "/portfolio-gallery";
            }
            if (originalUrl.includes("/signUp?ref")) {
                originalUrl = "/account";
            }
            window.location.replace(originalUrl); // Direct replacement
            sessionStorage.removeItem("originalUrl"); // Clear after use
        } else {
            console.error("Wallet login failed");
        }
    };

    // useEffect(() => {
    //     if (isConnected) {
    //         handleLoginClick();
    //     }
    // }, [isConnected]);
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    return (
        <>
            <div style={{textAlign: "center", marginBottom: "20px", width:"100%"}}>
                <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                    <appkit-button label="Login With Wallet" balance={"hide"} style={{zIndex: "10000"}} />
                </div>

                {isConnected && (
                    <button
                        onClick={() => handleLoginClick("")}
                        style={{
                            width: "80%",
                            padding: mediaQueryVar ? "4px 20px" : "3px 10px",
                            borderRadius: "1000px",
                            border: "1px solid black",
                            fontSize: "16px",
                            cursor: "pointer",
                            backgroundColor: "white",
                            color: "black",
                            marginBottom: mediaQueryVar === false ? "20px" : "30px",
                        }}
                    >
                        Login with wallet
                    </button>
                )}
            </div>
            {/* <SuccessPaymentAlert open={isSuccess} onClose={() => setIsSuccess(false)} /> */}
            <Snackbar
                open={snackbaropen}
                autoHideDuration={5000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            >
                <Alert severity={severity}>{alertMessage}</Alert>
            </Snackbar>
        </>
    );
};

export default ConnectButton;
